<template>
	<div class="leave_box"  v-loading="isTosub">
		<el-form label-position="top" :model="ruleForm" :rules="rules" ref="ruleForm">
			<el-form-item label="留言类型：" prop="type">
				<!-- <el-checkbox-group v-model="ruleForm.type">
					<el-checkbox v-for="item in interestList" :key="item.id" :label="item.id" name="type">{{item.title}}</el-checkbox>
				</el-checkbox-group> -->
				<el-radio-group v-model="ruleForm.type">
					<el-radio v-for="item in interestList" :key="item.id" :label="item.title">{{item.title}}</el-radio>
				</el-radio-group>
			</el-form-item>
			<el-form-item label="主题：" prop="title">
				<el-input v-model="ruleForm.title"></el-input>
			</el-form-item>
			<el-form-item label="填写邮箱：" prop="email">
				<el-input v-model="ruleForm.email" ></el-input>
				<span class="wenzi">您留言的回复消息会以邮件的形式发送哦~</span>
			</el-form-item>
			<el-form-item label="留言内容" prop="content">
				<el-input type="textarea" v-model="ruleForm.content"></el-input>
			</el-form-item>
			<el-form-item label="上传文件" prop="uploading">
				<el-upload class="upload-demo" action="/api/other/upload" :on-change="handleChange"
				:on-remove="handleRemove" v-model="ruleForm.file" :headers="{token}" :file-list="fileList"
				multiple name="files" :limit="1" accept=".gif,.png,.jpg,.word,.excel,.txt,.zip,.ppt,.pdf"   :on-success="handleSuccess" :before-upload="beforeAvatarUpload">
				<el-button size="small" type="primary">点击上传</el-button>
				</el-upload>
				<div class="red">注：您可以上传以下格式的文件 gif、jpg、png、word、excel、txt、zip、ppt、pdf</div>
			</el-form-item>
			<el-form-item>
				<div class="laing_btn next" @click="PostuserMessage">确定</div>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
import {mapState,mapMutations,mapActions} from 'vuex'
	export default {
		data() {
			return {
				isTosub:false,
				interestList:[],//感兴趣实验
				fileList:[],
				ruleForm: {
					type: [],//实验类型
					title: '',
					email: '',
					content: '',
					file:'',
				},
				rules: {
					type: [{ required: true, message: '请选择实验类型', trigger: 'change' }],
					title: [{ required: true, message: '请输入主题', trigger: 'blur' }],
					email: [{ required: true, message: '请输入邮箱', trigger: 'blur' }],
					content: [{ required: true, message: '请输入内容', trigger: 'blur' }],
					// uploading:{required: true,message: "请选择上传的文件", trigger: "change" }
				}
			}
		},
		created(){
			this.PostuserExperiment();
		},
		computed:{
			...mapState(['className','token'])
		},
		methods: {
			handleChange(file,filelist){
				if (filelist.length>0) {
					this.filelist=[filelist[filelist.length-1]]
				}
			},
			handleSuccess(res, file) {
                if (res.code == 200) {
					this.ruleForm.file = res.data;
					// this.rules.uploading.required = false;
                    this.$message.success('上传成功');
                }
            },
			async PostuserMessage(){//留言提交
				this.$refs.ruleForm.validate(async value=>{
					if(!value)return;
					this.isTosub = true;
					let {code} = await this.api.PostuserMessage(this.ruleForm);
					if(code==200){
						this.$refs.ruleForm.resetFields();
						this.$message.success('提交成功!');
					}
					this.isTosub = false;
				})
			},
			async PostuserExperiment(){//获取感兴趣实验
				let {data} = await this.api.PostuserExperiment();
				this.interestList =data;
			},
			beforeAvatarUpload(file){
				let isJPG =false;
				let type = file.name.substring(file.name.lastIndexOf('.')+1);
				switch(type){//gif、jpg、png、word、excel、txt、zip、ppt、pdf
					case 'gif':case 'jpg':case 'png':case 'word':case 'excel':case 'txt':case 'zip':case 'ppt':case 'pdf':
						isJPG= true;
					break;
				}
				const isLt2M = file.size / 1024 / 1024 < 50;
				if (!isJPG) {
					this.$message.error('上传文件只能是 gif、jpg、png、word、excel、txt、zip、ppt、pdf 格式!');
				}
				if (!isLt2M) {
					this.$message.error('上传文件大小不能超过 50MB!');
				}
				return isJPG && isLt2M;
			},
			handleRemove(file, fileList) {
      			// this.rules.uploading.required = true;
			},
		}
	}
</script>

<style lang="scss" scoped="scoped">
/deep/ .el-radio{
	margin-top: 10px;
	.el-radio__label{
		color:#606266;
	}
}
	.leave_box {
		width: 550px;
		.next{
			width: 280px;
		}
		.wenzi {
			color: #666666;
			font-size: 12px;
		}
		.red{
			font-size: 14px;
			font-family: PingFang-SC-Medium;
			color: #b03130;
			line-height: 30px;
		}
	}
</style>
